// extracted by mini-css-extract-plugin
module.exports = {"text":"SignupSuccessTemplate_text__JAi6_"};